<template>
  <div class="col-sm-12 col-md-6 col-lg-4">
    <div class="element-wrapper">
      <h6 class="element-header">{{ t('profileChangeEmail', 'profileChangeEmail')}}</h6>
      <div class="element-box">
        <form id="formUpdateEmail" v-on:submit.prevent="updateEmail">
          <h5 class="form-header"><i class="os-icon os-icon-mail-01"></i> {{ t('profileChangeEmail', 'profileChangeEmail')}}</h5>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="newEmail">* {{ t('profileChangeEmailLabel', 'profileChangeEmailLabel') }}</label>
                <input id="newEmail" name="newEmail" v-model="newEmail" class="form-control" autocomplete="off" :placeholder="t('profileChangeEmailPlaceholder', 'profileChangeEmailPlaceholder')" required="required" type="email">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="confirmEmail">* {{ t('profileChangeEmailConfirmLabel', 'profileChangeEmailConfirmLabel') }}</label>
                <input id="confirmEmail" name="confirmEmail" v-model="newEmailConfirm" autocomplete="off" class="form-control" :placeholder="t('profileChangeEmailConfirmLabel', 'profileChangeEmailConfirmLabel')" required="required" type="email">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="emailPass">* {{ t('profileChangeEmailPaswordLabel', 'profileChangeEmailPaswordLabel') }}</label>
                <input id="emailPass" name="emailPass" v-model="newEmailPass" class="form-control" data-minlength="6" :placeholder="t('profileChangeEmailPaswordLabel', 'profileChangeEmailPaswordLabel')" required="required" type="password">
              </div>
            </div>
          </div>
          <ResponseInfo v-if="getShowResponses.includes('showProfileEmailResponse')"/>
          <div class="form-buttons-w"><button v-bind:class="{ disabled: !newEmail || !newEmailConfirm || !newEmailPass}" class="btn btn-primary" type="submit" value="submit">{{ t('profileUpdateButton', 'profileUpdateButton')}}</button></div>
        </form>
      </div>
    </div>
  </div> <!-- ENDOF E-mail change form -->
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ProfileFormEmail',
  data() {
    return {
      newEmail: '',
      newEmailConfirm: '',
      newEmailPass: ''
    }
  },
  methods: {
    updateEmail() {
      this.$store.dispatch('updateEmail',{
        newEmail: this.newEmail,
        confirmEmail: this.newEmailConfirm,
        emailPass: this.newEmailPass
      })

      this.newEmail = ''
      this.newEmailConfirm = ''
      this.newEmailPass = ''
    }
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getShowResponses'])
  },
  components:{
    ResponseInfo
  }
}
</script>

<style>
</style>
